import ajaxRequest from './ajax'
import qs from "qs"

//活动负责人 创建vod 上传占位符
export const create_video_upload = params => {
  return ajaxRequest.post("vod/create_video_upload", params)
}

//活动负责人 刷新vod 上传占位符
export const refresh_video_upload = params => {
  return ajaxRequest.get('vod/refresh_video_upload?' + qs.stringify(params))
}

//api/vod/create_subtitle_upload
export const create_subtitle_upload = params => {
  return ajaxRequest.post("vod/create_subtitle_upload", params)
}

//api/vod/upload_subtitle_success
export const upload_subtitle_success = params => {
  return ajaxRequest.post("vod/upload_subtitle_success", params)
}

// 获取当前会议的vod
export const get_vod_by_tagging = params => {
  return ajaxRequest.post('vod/get_vod_by_tagging', params);
}

// 参会人 说明，或者播放地址
export const get_vod_play_preview_urls = params => {
  return ajaxRequest.get('vod/get_vod_play_preview_urls?' + qs.stringify(params));
}

// 活动负责人 删除Vod
export const delete_vod = params => {
  return ajaxRequest.get('vod/delete_vod?' + qs.stringify(params));
}

//获取视频转码进度
export const get_video_upload_info = params => {
  return ajaxRequest.post('vod/get_video_upload_info', params);
}

//获取视频管理列表 接口
export const get_vod_list = params => {
  return ajaxRequest.post("vod/get_vod_list", params)
}

//视频管理绑定标签 接口
export const mage_vod_tag = params => {
  return ajaxRequest.post("vod/mage_vod_tag", params)
}

// 视频管理 删除Vod
export const delete_vod_VM = params => {
  return ajaxRequest.get('vod/delete_video_session?' + qs.stringify(params));
}

// 获取单个vod视频 的信息
export const get_vod_by_id = params => {
  return ajaxRequest.get('vod/get_vod_by_id?' + qs.stringify(params));
}

//视频合成 接口
export const submit_jobs = params => {
  return ajaxRequest.post("vod/submit_jobs", params)
}


//预告资产 创建vod 上传占位符
export const event_upload_seasonal_video = params => {
  return ajaxRequest.post("event/upload_seasonal_video", params)
}
// 获取资产列表
export const get_seasonal_event_media_list = params => {
  return ajaxRequest.get("event/get_seasonal_event_media_list?" + qs.stringify(params))
}
// 删除资产
//预告资产 创建vod 上传占位符
export const delete_seasonal_media = params => {
  return ajaxRequest.post("event/delete_seasonal_media?" + qs.stringify(params))
}

// 获取 play_auth
export const get_seasonal_video_auth = params => {
  return ajaxRequest.get("event/get_seasonal_video_auth?" + qs.stringify(params))
}
// 视频绑定会议
export const session_binding_video = params => {
  return ajaxRequest.post("vod/session_binding_video", params)
}
// 视频绑定会议
export const video_binding_session = params => {
  return ajaxRequest.post("vod/video_binding_session", params)
}

// 解除视频与会议的关联
export const delete_vod_binding = params => {
  return ajaxRequest.post("vod/delete_vod_binding?" + qs.stringify(params))
}

// 视频排序
export const update_vod_map = params => {
  return ajaxRequest.post("vod/update_vod_map", params)
}

// 根据会议获取视频
export const get_vod_list_by_session_id = params => {
  return ajaxRequest.post("vod/get_vod_list_by_session_id", params )
}



// WEBPACK FOOTER //
// ./src/api/vod.js